import React, { ReactElement, useState } from 'react'
import { DatePicker, HeaderPage, Input, Select } from '@components/atoms'
import { ContainerPesquisa } from '@pages/style'
import { useForm } from 'react-hook-form'
import { Button, Col, Row, Typography, Table, Spin, Drawer } from 'antd'
import { Content } from 'antd/lib/layout/layout'
import { SearchOutlined } from '@ant-design/icons'

const data = [
  {
    DESCPRODUTO: 'MousePad Redragon',
    GRUPO: 'Grupo 1',
    MARCA: 'Marca 1',
    CUSTOAQUISICAO: ' R$ 14,00',
    PRECOVENDA: ' R$ 110,00',
  },
  {
    DESCPRODUTO: 'MousePad Redragon',
    GRUPO: 'Grupo 1',
    MARCA: 'Marca 1',
    CUSTOAQUISICAO: ' R$ 14,00',
    PRECOVENDA: ' R$ 110,00',
  },
  {
    DESCPRODUTO: 'MousePad Redragon',
    GRUPO: 'Grupo 1',
    MARCA: 'Marca 1',
    CUSTOAQUISICAO: ' R$ 14,00',
    PRECOVENDA: ' R$ 110,00',
  },
  {
    DESCPRODUTO: 'MousePad Redragon',
    GRUPO: 'Grupo 1',
    MARCA: 'Marca 1',
    CUSTOAQUISICAO: ' R$ 14,00',
    PRECOVENDA: ' R$ 110,00',
  },
  {
    DESCPRODUTO: 'MousePad Redragon',
    GRUPO: 'Grupo 1',
    MARCA: 'Marca 1',
    CUSTOAQUISICAO: ' R$ 14,00',
    PRECOVENDA: ' R$ 110,00',
  },
  {
    DESCPRODUTO: 'MousePad Redragon',
    GRUPO: 'Grupo 1',
    MARCA: 'Marca 1',
    CUSTOAQUISICAO: ' R$ 14,00',
    PRECOVENDA: ' R$ 110,00',
  },
]

export default function ProdutosInativos(): ReactElement {
  const { control, watch, reset } = useForm()
  const { Option } = Select
  // const methods = useForm()
  const allFields = /* methods. */ watch()
  const { Column } = Table
  const [spinning, setSpinning] = useState(false)
  const [visible, setVisible] = useState(false)

  const showDrawer = () => {
    setVisible(true)
  }

  const onClose = () => {
    setVisible(false)
  }

  const limparFiltros = () => {
    reset()
  }

  const filtrarResultados = (/* props: {
    agrupamento: string
    cliente: string
    dtinicio: string
    dtfinal: string
    valor: string
  } */) => {
    /* data.filter((value) => {
      setSpinning(true)
      const dataFilter = value.AGRUPAMENTO === props.agrupamento
      console.log(value.AGRUPAMENTO === props.agrupamento)
      setSpinning(false)
      return dataFilter
    }) */
  }

  return (
    <ContainerPesquisa>
      <Content style={{ padding: 24 }}>
        <Spin tip='Filtrando...' spinning={spinning}>
          <HeaderPage
            title='Produtos Inativos'
            extra={[
              <Button
                key='buttonSearch'
                className='buttonSearch'
                onClick={() => showDrawer()}
              >
                <p>Filtrar</p>
                <SearchOutlined key='iconSearch' className='iconSearch' />
              </Button>,
            ]}
          />
          <Table dataSource={data}>
            <Column title='Descrição do Produto' dataIndex={'DESCPRODUTO'} />
            <Column title='Grupo' dataIndex={'GRUPO'} />
            <Column title='Marca' dataIndex={'MARCA'} />
            <Column title='Custo Aquisição' dataIndex={'CUSTOAQUISICAO'} />
            <Column title='Preço de Venda' dataIndex={'PRECOVENDA'} />
          </Table>
        </Spin>
      </Content>
      <Drawer
        onClose={onClose}
        visible={visible}
        title='Filtros'
        style={{ marginTop: '4rem' }}
      >
        <Row key='mainRow'>
          <Col span={24}>
            <Typography.Title level={5}>Campo Pesquisado</Typography.Title>
            <Select
              control={control}
              allowClear
              name='CAMPOPESQUISADO'
              placeholder='Campo Pesquisado'
            >
              <Option value='Descrição'>Descrição</Option>
              <Option value='Código Interno'>Código Interno</Option>
              <Option value='Código de Barras'>Código de Barras</Option>
              <Option value='Código Fabricação'>Código Fabricação</Option>
              <Option value='Código Referência'>Código Referência</Option>
            </Select>
          </Col>
          <Col span={24}>
            <Typography.Title level={5}>Conteúdo Pesquisado</Typography.Title>
            <Input
              control={control}
              name='CONTEUDOPESQUISADO'
              placeholder='Conteúdo Pesquisado'
            />
          </Col>
          <Col span={allFields.GRUPO === 'Específico' ? 7 : 24}>
            <Typography.Title level={5}>Grupo</Typography.Title>
            <Select
              control={control}
              allowClear
              defaultValue='Todos'
              name='GRUPO'
              placeholder='Grupo'
            >
              <Option value='Todos'>Todos</Option>
              <Option value='Específico'>Específico</Option>
            </Select>
          </Col>
          {allFields.GRUPO === 'Específico' ? (
            <Col span={17}>
              <Typography.Title level={5}>Grupo Específico</Typography.Title>
              <Select
                control={control}
                allowClear
                name='GRUPOESPEC'
                placeholder='Grupo Específico'
              >
                <Option value='Grupo 1'>Grupo 1</Option>
                <Option value='Grupo 2'>Grupo 2</Option>
              </Select>
            </Col>
          ) : null}
          <Col span={allFields.SUBGRUPO === 'Específico' ? 7 : 24}>
            <Typography.Title level={5}>SubGrupo</Typography.Title>
            <Select
              control={control}
              allowClear
              defaultValue='Todos'
              name='SUBGRUPO'
              placeholder='SubGrupo'
            >
              <Option value='Todos'>Todos</Option>
              <Option value='Específico'>Específico</Option>
            </Select>
          </Col>
          {allFields.SUBGRUPO === 'Específico' ? (
            <Col span={17}>
              <Typography.Title level={5}>SubGrupo Específico</Typography.Title>
              <Select
                control={control}
                allowClear
                name='SUBGRUPOESPEC'
                placeholder='SubGrupo Específico'
              >
                <Option value='SubGrupo 1'>SubGrupo 1</Option>
                <Option value='SubGrupo 2'>SubGrupo 2</Option>
              </Select>
            </Col>
          ) : null}
          <Col span={allFields.MARCA === 'Específica' ? 7 : 24}>
            <Typography.Title level={5}>Marca</Typography.Title>
            <Select
              control={control}
              allowClear
              defaultValue='Todos'
              name='MARCA'
              placeholder='Marca'
            >
              <Option value='Todos'>Todos</Option>
              <Option value='Específica'>Específica</Option>
            </Select>
          </Col>
          {allFields.MARCA === 'Específica' ? (
            <Col span={17}>
              <Typography.Title level={5}>Marca Específica</Typography.Title>
              <Select
                control={control}
                allowClear
                name='MARCAESPEC'
                placeholder='Marca Específica'
              >
                <Option value='Marca 1'>Marca 1</Option>
                <Option value='Marca 2'>Marca 2</Option>
              </Select>
            </Col>
          ) : null}
          <Col span={24} style={{ marginTop: '1.5rem' }}>
            <Row gutter={5}>
              <Col>
                <Button
                  danger
                  type='default'
                  onClick={() => {
                    limparFiltros()
                  }}
                  style={{
                    width: 110,
                  }}
                >
                  Limpar filtro
                </Button>
              </Col>
              <Col>
                <Button
                  type='primary'
                  onClick={() => {
                    filtrarResultados(/* {
                      agrupamento: allFields.AGRUPAMENTO_ESPEC,
                      cliente: allFields.CLIENTE_ESPEC,
                      dtinicio: allFields.DTINICIO,
                      dtfinal: allFields.DTFINAL,
                      valor: allFields.VALOR,
                    } */)

                    onClose()
                  }}
                  style={{
                    width: 110,
                  }}
                >
                  Filtrar
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Drawer>
    </ContainerPesquisa>
  )
}
